import { render, staticRenderFns } from "./CFNoteHighlightList.vue?vue&type=template&id=554be68e&"
import script from "./CFNoteHighlightList.vue?vue&type=script&lang=ts&"
export * from "./CFNoteHighlightList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports